import React, { useState } from 'react';

interface ResetPasswordProps {
  token: string;
  onBackToLogin: () => void;
}

const ResetPassword: React.FC<ResetPasswordProps> = ({ token, onBackToLogin }) => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [success, setSuccess] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (name === 'confirmPassword') {
      setConfirmPassword(value);
    } else {
      setNewPassword(value);
    }
    setError('');
    setSuccess('');
  };

  const validateForm = (): boolean => {
    if (!newPassword || !confirmPassword) {
      setError('Tüm alanlar doldurulmalıdır');
      return false;
    }

    if (newPassword.length < 6) {
      setError('Yeni şifre en az 6 karakter olmalıdır');
      return false;
    }

    if (newPassword !== confirmPassword) {
      setError('Şifreler eşleşmiyor');
      return false;
    }

    return true;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!validateForm()) return;

    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const response = await fetch('/api/auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, newPassword }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Şifre sıfırlama başarısız');
      }

      setSuccess(data.message || 'Şifreniz başarıyla sıfırlandı!');
      
      setTimeout(() => {
        onBackToLogin();
      }, 2000);
      
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Şifre sıfırlama başarısız');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-form">
        <h2>🔐 Yeni Şifre Oluştur</h2>
        <p className="form-description">
          Hesabınız için yeni bir şifre oluşturun.
        </p>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="newPassword">Yeni Şifre</label>
            <input
              type="password"
              id="newPassword"
              name="newPassword"
              value={newPassword}
              onChange={handleChange}
              required
              placeholder="Yeni şifrenizi girin (en az 6 karakter)"
              className="form-input"
              minLength={6}
            />
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">Yeni Şifre (Tekrar)</label>
            <input
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              value={confirmPassword}
              onChange={handleChange}
              required
              placeholder="Yeni şifrenizi tekrar girin"
              className="form-input"
              minLength={6}
            />
          </div>

          {error && <div className="error-message">{error}</div>}
          {success && <div className="success-message">{success}</div>}

          <button 
            type="submit" 
            disabled={loading} 
            className="auth-button"
          >
            {loading ? 'Şifre Oluşturuluyor...' : 'Yeni Şifre Oluştur'}
          </button>
        </form>

        <div className="password-tips">
          <h3>🛡️ Güçlü Şifre İpuçları</h3>
          <ul>
            <li>En az 6 karakter kullanın</li>
            <li>Büyük ve küçük harfler karışık kullanın</li>
            <li>Sayılar ve semboller ekleyin</li>
            <li>Kişisel bilgiler kullanmayın</li>
            <li>Aynı şifreyi birden fazla yerde kullanmayın</li>
          </ul>
        </div>

        <div className="auth-footer">
          <p>
            Şifrenizi hatırladınız mı?{' '}
            <button 
              type="button" 
              onClick={onBackToLogin}
              className="link-button"
            >
              Giriş Yap
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
